module.exports = __webpack_public_path__ + "95ca40a9d69b1e8c52d36206b6f461de.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/style_imagery_bestpractices_narrative1.png
// module id = 707
// module chunks = 0